/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./oauthConsent.vue?vue&type=template&id=44bc4cfe&scoped=true&"
import script from "./oauthConsent.vue?vue&type=script&lang=js&"
export * from "./oauthConsent.vue?vue&type=script&lang=js&"
import style0 from "./oauthConsent.vue?vue&type=style&index=0&id=44bc4cfe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bc4cfe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VApp,VAvatar,VBtn,VCardText,VCol,VContainer,VForm,VIcon,VImg,VRow})
